import React from "react";
import "./common.scss";
import Success from "../../assets/gif/success.gif";
import Error from "../../assets/gif/error.gif";

const Modal = ({
  isOpen,
  onClose,
  title,
  btnTitle,
  children,
  type = "success",
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-backdrop">
      <div className={`modal-container`}>
        <div className="gif-show">
          {type === 'success' ? (
            <img src={Success} alt="Success" />
          ):(
            <img src={Error} alt="Error" />
          )}
        </div>
        {title ? <h3 className="modal-title">{title}</h3> : null}
        <div className="modal-content">{children}</div>

        <button className="modal-btn" onClick={onClose}>
          {btnTitle}
        </button>
      </div>
    </div>
  );
};

export default Modal;
